module.exports = __webpack_public_path__ + "images/emoji/shit.d12d38e92a2adf59aa73.png";